import PropTypes from 'prop-types';
import StyledAutoComplete from './StyledAutoComplete';
import { Stack, Typography } from '@mui/material';
import SearchFilterUtil from 'lib/SearchFilterUtil';
import TextField from 'components/commons/TextField';
import StyledTooltip from 'components/commons/StyledTooltip';

function RpSelect({
    value,
    onChange,
    disabled,
    label = 'Select',
    options = [],
    errorMessage = null,
    isDefault = true,
    title,
    subTitle,
    maxInputLength,
}) {
    const getIsOptionEqualToValue = (option, value) => option.value === value?.value;

    const formatValue = (val) => {
        if (typeof val === 'string') {
            const matchedOption = options.find(opt => opt.value === val);
            return matchedOption || { label: val, value: val };
        }
        return val;
    };
    const getNewParams = (params) => ({
        ...params,
        onInput: (e) =>
            SearchFilterUtil.handleAutocompleteInputChange(e, { params, maxInputLength }),
    });

    return (
        <>
            <Stack spacing={2} mb={0.5}>
                <Typography variant="text1" gutterBottom>{title}</Typography>
            </Stack>
            <Stack spacing={2} mb={1}>
                <Typography variant="subtitle1" gutterBottom>{subTitle}</Typography>
            </Stack>
            <Stack spacing={2} mb={1}>
                <StyledTooltip title={value?.label ?? value?.value ?? value} type="light">
                    <StyledAutoComplete
                        disablePortal
                        options={options}
                        value={formatValue(value)}
                        isOptionEqualToValue={getIsOptionEqualToValue}
                        onChange={(event, newValue) => {
                            onChange(newValue);
                        }}
                        freeSolo
                        disableClearable
                        renderInput={(params) => {
                            const formattedValue = formatValue(value);
                            const hasValue = formattedValue && formattedValue.value !== '' && formattedValue.value !== undefined && formattedValue.value !== null;
                            return (
                                <TextField
                                    params={getNewParams(params)}
                                    label={label}
                                    isHighlighted={hasValue ? true : !isDefault}
                                    error={!!errorMessage}
                                />
                            );
                        }}
                        filterOptions={SearchFilterUtil.filterOptions}
                        data-testid="mui-select-auto-complete"
                        clearOnBlur
                        selectOnFocus
                        autoHighlight
                        disabled={disabled}
                        forcePopupIcon
                    />
                </StyledTooltip>
                {
                    errorMessage &&
                    <span
                        className="rp-select-error-message"
                    >
                    {errorMessage}
                </span>
                }
            </Stack>
        </>
    );
}

RpSelect.propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    shouldUpdateInputText: PropTypes.func,
    id: PropTypes.string,
    label: PropTypes.string,
    options: PropTypes.array.isRequired,
    errorMessage: PropTypes.string,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    isDefault: PropTypes.bool,
    isInputReadOnly: PropTypes.bool,
    maxLength: PropTypes.number,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    maxInputLength: PropTypes.number,
};

export default RpSelect;
